// Qalam theme JS — slider, carrousels, menu mobile, quantités

// Hero slider
document.querySelectorAll('[data-hero]').forEach((hero) => {
  const slides = hero.querySelectorAll('.hero-slide');
  const dots = hero.querySelectorAll('.hero-dots button');
  if (slides.length < 2) return;
  let current = 0;
  let timer;

  const goTo = (i) => {
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');
    current = (i + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current]?.classList.add('active');
  };
  const restart = () => { clearInterval(timer); timer = setInterval(() => goTo(current + 1), 5000); };

  hero.querySelector('.hero-arrow.prev')?.addEventListener('click', () => { goTo(current - 1); restart(); });
  hero.querySelector('.hero-arrow.next')?.addEventListener('click', () => { goTo(current + 1); restart(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); restart(); }));
  restart();
});

// Carrousels produits
document.querySelectorAll('[data-carousel]').forEach((section) => {
  const track = section.querySelector('.carousel');
  section.querySelector('[data-prev]')?.addEventListener('click', () => track.scrollBy({ left: -280, behavior: 'smooth' }));
  section.querySelector('[data-next]')?.addEventListener('click', () => track.scrollBy({ left: 280, behavior: 'smooth' }));
});

// Menu mobile
document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const menu = document.getElementById(btn.getAttribute('aria-controls'));
    const open = menu.hasAttribute('hidden');
    menu.toggleAttribute('hidden', !open);
    btn.setAttribute('aria-expanded', open);
  });
});

// Boutons +/- quantité
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty]');
  if (!btn) return;
  e.preventDefault();
  const input = btn.parentElement.querySelector('input');
  const delta = btn.dataset.qty === 'plus' ? 1 : -1;
  input.value = Math.max(Number(input.min || 1), Number(input.value) + delta);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// Galerie produit : clic vignette → image principale
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const main = gallery.querySelector('[data-gallery-main]');
  gallery.querySelectorAll('.product-thumbs img').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      main.src = thumb.dataset.full;
      gallery.querySelector('.product-thumbs img.active')?.classList.remove('active');
      thumb.classList.add('active');
    });
  });
});

// Nav scroll arrows
document.querySelectorAll('[data-nav-track]').forEach((track) => {
  const container = track.closest('.nav-container');
  if (!container) return;
  const prevBtn = container.querySelector('[data-nav-prev]');
  const nextBtn = container.querySelector('[data-nav-next]');
  const update = () => {
  if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
  if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
};
if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -150, behavior: 'smooth' }));
if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: 150, behavior: 'smooth' }));
track.addEventListener('scroll', update);
window.addEventListener('resize', update);
update();
});